export default {"src":"https://static.finncdn.no/_c/travel/pp-web/_next/static/media/g3.8dc6d886.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};